export default __webpack_public_path__ + "static/media/brands.929a2aa5.png";